<template>
  <div>
    <div><img src="/img/logo.svg" width="100" height="100" /></div>

    <b-container class="form-container ta-left">
      <!-- Account is existing -->
      <transition name="slide-fade">
        <b-form @submit.prevent="onSubmit" v-show="current !== 'show-register'">
          <transition name="slide-fade">
            <b-form-group
              id="input-group-1"
              class="col-12"
              v-show="current === 'show-email'"
            >
              <b-form-input
                id="input-1"
                v-model="form.email"
                class="effect-26"
                :class="form.email ? 'has-content' : ''"
                type="email"
                placeholder="Enter email address"
                autofocus
                @input="form.$clearError('email')"
              ></b-form-input>
              <label>Email Address</label>
              <span class="focus-border"></span>
            </b-form-group>
            <div class="input-error" v-if="form.$getError('email')">
              {{ form.$getError('email')[0] }}
            </div>
          </transition>

          <transition name="slide-fade">
            <b-form-group
              id="input-group-2"
              class="col-12"
              v-show="current === 'show-password'"
            >
              <b-form-input
                id="input-2"
                v-model="form.password"
                class="effect-26"
                :class="form.password ? 'has-content' : ''"
                type="password"
                autocomplete="new-password"
                placeholder="Enter password"
                @input="form.$clearError('password')"
              ></b-form-input>
              <label>Password</label>
              <span class="focus-border"></span>
            </b-form-group>
            <div class="input-error" v-if="form.$getError('password')">
              {{ form.$getError('password')[0] }}
            </div>
          </transition>

          <div class="ta-right mt-4">
            <b-button
              class="form-button full-width"
              type="submit"
              variant="primary"
            >
              <b-spinner small v-if="form.$busy"></b-spinner>
              <div v-else>GO</div>
            </b-button>
          </div>
        </b-form>
      </transition>

      <!-- Account is NOT yet existing -->
      <transition name="slide-fade">
        <b-form @submit="onSubmit" v-show="current === 'show-register'">
          <b-form-group id="input-group-3" class="col-12">
            <b-form-input
              id="input-3"
              v-model="form.first_name"
              class="effect-26"
              :class="form.first_name ? 'has-content' : ''"
              type="text"
              required
              placeholder="Enter first name"
              @input="form.$clearError('first_name')"
            ></b-form-input>
            <label>First Name</label>
            <span class="focus-border"></span>
          </b-form-group>
          <div class="input-error" v-if="form.$getError('first_name')">
            {{ form.$getError('first_name')[0] }}
          </div>

          <b-form-group id="input-group-4" class="col-12">
            <b-form-input
              id="input-4"
              v-model="form.last_name"
              class="effect-26"
              :class="form.last_name ? 'has-content' : ''"
              type="text"
              required
              placeholder="Enter last name"
              @input="form.$clearError('last_name')"
            ></b-form-input>
            <label>Last Name</label>
            <span class="focus-border"></span>
          </b-form-group>
          <div class="input-error" v-if="form.$getError('last_name')">
            {{ form.$getError('last_name')[0] }}
          </div>

          <b-form-group id="input-group-5" class="col-12">
            <b-form-input
              id="input-5"
              v-model="form.phone_number"
              class="effect-26"
              :class="form.phone_number ? 'has-content' : ''"
              type="text"
              required
              placeholder="Enter phone number"
              @input="form.$clearError('phone_number')"
            ></b-form-input>
            <label>Phone Number</label>
            <span class="focus-border"></span>
          </b-form-group>
          <div class="input-error" v-if="form.$getError('phone_number')">
            {{ form.$getError('phone_number')[0] }}
          </div>

          <b-form-group id="input-group-6" class="col-12">
            <b-form-input
              id="input-6"
              v-model="form.password"
              class="effect-26"
              :class="form.password ? 'has-content' : ''"
              type="password"
              autocomplete="new-password"
              required
              placeholder="Enter password"
              @input="form.$clearError('password')"
            ></b-form-input>
            <label>Password</label>
            <span class="focus-border"></span>
          </b-form-group>
          <div class="input-error" v-if="form.$getError('password')">
            {{ form.$getError('password')[0] }}
          </div>

          <b-form-group id="input-group-7" class="col-12">
            <b-form-input
              id="input-7"
              v-model="form.password_confirmation"
              class="effect-26"
              :class="form.password_confirmation ? 'has-content' : ''"
              type="password"
              autocomplete="new-password"
              required
              placeholder="Enter password confirmation"
              @input="form.$clearError('password_confirmation')"
            ></b-form-input>
            <label>Confirm Password</label>
            <span class="focus-border"></span>
          </b-form-group>
          <div
            class="input-error"
            v-if="form.$getError('password_confirmation')"
          >
            {{ form.$getError('password_confirmation')[0] }}
          </div>

          <div class="ta-right mt-4">
            <b-button
              class="form-button full-width"
              type="submit"
              variant="primary"
            >
              <b-spinner small v-if="form.$busy"></b-spinner>
              <div v-else>SIGN UP</div>
            </b-button>
          </div>
        </b-form>
      </transition>
    </b-container>
  </div>
</template>

<script>
import Form from '@/utils/form'

export default {
  data() {
    return {
      form: new Form({
        email: '',
        phone_number: '',
        first_name: '',
        last_name: '',
        password: '',
        password_confirmation: ''
      }),
      current: 'show-email'
    }
  },
  methods: {
    async onSubmit(evt) {
      this.form.$busy = true
      if (this.current === 'show-email') {
        await this.$api
          .post('auth/check-email', {
            email: this.form.$data().email
          })
          .then(({ data }) => {
            this.form.$busy = false
            this.current = 'show-password'
          })
          .catch(error => {
            this.form.$busy = false
            if (error.response.data.error_code === 'EMAIL_NOT_FOUND') {
              this.current = 'show-register'
            }
          })
      } else if (this.current === 'show-register') {
        // if email does not exists
        await this.$api
          .post('auth/register', this.form.$data())
          .then(({ data }) => {
            this.form.$busy = false
            this.$store.commit('auth/setToken', data.data)
            this.$router.replace({ name: 'user.profile-page' })
          })
          .catch(error => {
            this.form.$handleError(error)
          })
      } else {
        // if email exists
        await this.$api
          .post('auth/login', {
            username: this.form.$data().email, // this accepts email or phone number in API; for web app, email should suffice
            password: this.form.$data().password
          })
          .then(({ data }) => {
            this.form.$busy = false
            this.$store.commit('auth/setToken', data.data)
            this.$router.replace({ name: 'user.profile-page' })
          })
          .catch(error => {
            this.form.$handleError(error)
          })
      }
    }
  }
}
</script>
